import http from '../../utils/http';
const rootUrl = '/api';
const Model = {
	/**
	 * 获取已绑定的设备型号列表
	 */
	getBoundList( params ) {
		return http.get( `${rootUrl}/queryBoundModelApi`, { params });
	},
	/**
	 * 获取软件下载列表
	 */
	software( params ) {
		return http.get( `${rootUrl}/queryModelSoftwareAPI`, { params });
	},
	/**
	 * 获取操作视频+进阶资料
	 * @returns
	 */
	getDocList( params ) {
		return http.get( `${rootUrl}/queryModelDocumentListAPI`, { params });
	},
	/**
	 * 获取设备信息，如果无返回表示该账号下无该产品用户信息
	 * @param {string} modelCode
	 * @param {string} lang
	 * @param {string} esn
	 * @param {string} sn
	 * @param {string} productline
	 * @returns
	 */
	getModelDetail( params ) {
		return http.get( `${rootUrl}/queryUserCompanyByModelCodeAPI`, { params });
	},
	/**
	 * 获取所有设备型号
	 * @param {string} lang
	 * @returns
	 */
	getAllModelList( params ) {
		return http.get( `${rootUrl}/getModelInfoByDeviceType`, { params });
	},
	/**
	 *  发送反馈邮件
	 */
	feedback( data ) {
		return http.post( `${rootUrl}/bindDeviceFeedbackAPIV2`, { data });
	},
	/**
	 * 获取配套软件
	 * @param {string} lang
	 */
	getSoftWareInfo( params ) {
		return http.get( `${rootUrl}/querySoftwareAPI`, { params });
	}
};

export default Model;
